import { Box, Container, Text, Title, Button, Group, Stack, Card, Grid, ThemeIcon, Center } from '@mantine/core';
import { PlayerPlay, MessageCircle, Users, Shield } from 'tabler-icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { selectAuthState, login } from '../auth/authSlice';

function HomePage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const authState = useAppSelector(selectAuthState);
  const isAuthenticated = authState === 'authenticated';

  return (
    <Container size="lg" py={60}>
      <Stack spacing={80}>
        <Box style={{ textAlign: 'center' }}>
          <Title order={1} mb="xl" style={{ fontWeight: 800, fontSize: 48 }}>
            StreamerKit React
          </Title>
          <Text size="xl" color="dimmed" mb="xl" style={{ maxWidth: 600, margin: '0 auto 2rem' }}>
            Deixe sua comunidade compartilhar clipes diretamente do chat. Enfileire e reproduza automaticamente clipes do Twitch, YouTube e muito mais.
          </Text>
          <Group position="center" spacing="md">
            {isAuthenticated ? (
              <Button size="lg" onClick={() => navigate('/queue')}>
                Abrir Fila
              </Button>
            ) : (
              <Button size="lg" onClick={() => dispatch(login(location.pathname))}>
                Começar com Twitch
              </Button>
            )}
          </Group>
        </Box>

        <Grid gutter="xl">
          <Grid.Col xs={12} sm={6} md={3}>
            <Card shadow="sm" p="lg" radius="md" withBorder style={{ height: '100%' }}>
              <Center mb="md">
                <ThemeIcon size={60} radius="md" variant="light">
                  <PlayerPlay size={32} />
                </ThemeIcon>
              </Center>
              <Title order={3} align="center" mb="sm">
                Reprodução Automática
              </Title>
              <Text size="sm" color="dimmed" align="center">
                Enfileire e reproduza automaticamente clipes compartilhados pelos seus espectadores em tempo real
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} sm={6} md={3}>
            <Card shadow="sm" p="lg" radius="md" withBorder style={{ height: '100%' }}>
              <Center mb="md">
                <ThemeIcon size={60} radius="md" variant="light">
                  <MessageCircle size={32} />
                </ThemeIcon>
              </Center>
              <Title order={3} align="center" mb="sm">
                Integração com Chat
              </Title>
              <Text size="sm" color="dimmed" align="center">
                Integra-se perfeitamente com o chat da Twitch para capturar links de clipes instantaneamente
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} sm={6} md={3}>
            <Card shadow="sm" p="lg" radius="md" withBorder style={{ height: '100%' }}>
              <Center mb="md">
                <ThemeIcon size={60} radius="md" variant="light">
                  <Users size={32} />
                </ThemeIcon>
              </Center>
              <Title order={3} align="center" mb="sm">
                Movido pela Comunidade
              </Title>
              <Text size="sm" color="dimmed" align="center">
                Clipes populares ganham prioridade quando compartilhados por vários espectadores
              </Text>
            </Card>
          </Grid.Col>

          <Grid.Col xs={12} sm={6} md={3}>
            <Card shadow="sm" p="lg" radius="md" withBorder style={{ height: '100%' }}>
              <Center mb="md">
                <ThemeIcon size={60} radius="md" variant="light">
                  <Shield size={32} />
                </ThemeIcon>
              </Center>
              <Title order={3} align="center" mb="sm">
                Privacidade em Primeiro Lugar
              </Title>
              <Text size="sm" color="dimmed" align="center">
                Sem armazenamento de dados. Tudo roda no seu navegador. Totalmente de código aberto
              </Text>
            </Card>
          </Grid.Col>
        </Grid>

        <Box style={{ textAlign: 'center', padding: '2rem 0' }}>
          <Title order={2} mb="md">
            Plataformas Suportadas
          </Title>
          <Text size="lg" color="dimmed">
            Twitch Clips · Kick Clips · Afreeca Clips · YouTube · Streamable · X (Twitter) · TikTok · Instagram
          </Text>
        </Box>
      </Stack>
    </Container>
  );
}

export default HomePage;
